interface IErrors {
  actionName?: string;
}

export const validate = (values) => {
  const errors: IErrors = {};

  if (!values.actionName) {
    errors.actionName = "Required";
  } else if (values.actionName.length > 250) {
    errors.actionName = "Maximum length 250 characters";
  }

  return errors;
};